import React, { forwardRef } from 'react';
import { SnackbarContent, SnackbarMessage } from 'notistack';
import { Icon, IconColorOptions } from '../Icon';

import './styles.scss';

export interface SnackBar {
    id: string;
    title?: string;
    message?: SnackbarMessage;
    icon?: string;
    iconColor?: IconColorOptions;
    dismissed?: boolean;
}

interface Props extends SnackBar {
    onClose: () => void;
}

// eslint-disable-next-line react/display-name
export const SnackBar = forwardRef<HTMLDivElement, Props>(
    ({ title, message, icon, iconColor, onClose, ...other }, ref) => {
        return (
            <SnackbarContent ref={ref} role='alert' {...other}>
                <div className='app-snackbar'>
                    {icon && <Icon icon={icon} color={iconColor} size='20px' className='app-snackbar__icon' />}
                    <div className='app-snackbar__content'>
                        <span className='app-snackbar__title'>{title}</span>
                        <span className='app-snackbar__message'>{message}</span>
                    </div>
                    <button className='app-snackbar__close-button' onClick={onClose}>
                        <Icon icon='xmark-regular' color='white' size='20px' />
                    </button>
                </div>
            </SnackbarContent>
        );
    },
);
